// ProtectedRoute.jsx
//
// OJO: esto NO es seguridad. La clave anon de Supabase va dentro del bundle y es
// publica, asi que cualquiera puede llamar a la API sin pasar por aca. La
// barrera real es el RLS de Postgres (ver supabase/20260305_rls_hardening.sql).
//
// Lo que hace este componente es no renderizar el panel de admin a un cliente
// normal: evita que vea la UI ni los datos que si puede leer de otro lado.
//
// Antes solo miraba que hubiera sesion, sin verificar el rol, asi que cualquier
// usuario registrado abria /admin, /contratos y /admin-sesiones.
import { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";
import { supabase } from "../Supabase/SupabaseClient.js";

const ProtectedRoute = ({ element }) => {
  const [estado, setEstado] = useState({ user: null, rol: null, loading: true });

  useEffect(() => {
    let vivo = true;

    const getUser = async () => {
      const {
        data: { user },
        error,
      } = await supabase.auth.getUser();

      if (!vivo) return;

      if (error || !user) {
        setEstado({ user: null, rol: null, loading: false });
        return;
      }

      // El rol decide si esta persona entra al panel. Solo el admin.
      const { data: perfil } = await supabase
        .from("usuarios")
        .select("rol")
        .eq("id", user.id)
        .maybeSingle();

      if (!vivo) return;

      setEstado({
        user,
        // AuthListenerWrapper.js compara con 'Admin' y AdminSesiones.js con
        // 'admin'; en la base esta mezclado, asi que normalizamos en minuscula.
        rol: String(perfil?.rol ?? "").toLowerCase(),
        loading: false,
      });
    };

    getUser();
    return () => { vivo = false; };
  }, []);

  if (estado.loading) return <div>Loading...</div>;

  if (!estado.user) {
    return <Navigate to="/login" />;
  }

  // Sesion valida pero sin rol de admin: al inicio, no a una ruta de admin.
  if (estado.rol !== "admin") {
    return <Navigate to="/" />;
  }

  return element;
};

export default ProtectedRoute;
